// extracted by css-extract-rspack-plugin
export default {"container":"RepositoryPicker-module__container__Pp4hn","label":"RepositoryPicker-module__label__dRQAI","ssoBanner":"RepositoryPicker-module__ssoBanner__zkkig"};